<div class="welcome-container">
  <img 
    src="https://possoagendar.com.br/assets/logo-posso-agendar-borda-azul-desktop.svg" 
    alt="Logo" 
    class="welcome-logo" 
  />

  <h1 class="welcome-title">Seja bem-vindo(a)! 👋</h1>
  
  <p class="welcome-message">
    É um prazer ter você com a gente!  
    Para começar a aproveitar tudo o que a plataforma oferece, vamos dar os primeiros passos juntos:
  </p>

  <ul class="welcome-list">
    <li>📌 Complete seu <strong>perfil</strong></li>
    <li>📍 Defina sua <strong>localização</strong></li>
    <li>⏰ Configure seu <strong>horário de atendimento</strong></li>
  </ul>

  <p class="welcome-message">
    Assim você terá acesso a todas as funcionalidades e a melhor experiência possível.
  </p>

  <button mat-raised-button color="primary" (click)="closeDialog()">
    Iniciar configuração
  </button>
</div>